import styled from "styled-components";

export const FeedbackContainer = styled.div`
    height: 14vh;
    display: flex;
    align-items: center;
`;
